import { render, staticRenderFns } from "./BatchEditVD.vue?vue&type=template&id=b14a9a20&scoped=true"
import script from "./BatchEditVD.vue?vue&type=script&lang=ts"
export * from "./BatchEditVD.vue?vue&type=script&lang=ts"
import style0 from "./BatchEditVD.vue?vue&type=style&index=0&id=b14a9a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14a9a20",
  null
  
)

export default component.exports